<formio-loader></formio-loader>

<div class="row">
	<div class="col-12" *ngIf="downloadPDF">
		<!-- <p-button (click)="showDialog()" icon="pi pi-external-link" label="Show Table"></p-button> -->
		<button type="button" (click)="showDialog()" class="btn btn-outline-light btn-download-pdf"
			[pTooltip]="'forms.common.Download PDF' | translate" tooltipPosition="top">
			<mat-icon class="pdf-mat-icon"> picture_as_pdf</mat-icon>
		</button>

		<p-dialog [(visible)]="openDialog" [style]="{ width: '70vw' }" [position]="'top'" [modal]="true"
			[baseZIndex]="10000" [draggable]="false" [resizable]="false">
			<div *ngIf="showLoader">
				<div class="table-formio-loader">
					<div class="table-formio-loader-wrapper"></div>
					<div class="table-formio-loader"></div>
				</div>
				<span class="pdf-span">{{ 'forms.common.Generating PDF Report' | translate }} </span>
			</div>

			<div id="summaryContainer" class="summaryContainerClass">
				<div class="row">
					<div class="col-12 text-center">
						<img src="assets/images/brand/brand.png" alt="App Brand" class="img-fluid" />
					</div>
				</div>

				<div class="row">
					<div class="col-12">
						<formio *ngIf="openDialog" [showLoader]="false" [formKey]="customOptions?.pdfResourceKey"
							[submission]="submission">
						</formio>
					</div>
				</div>

				<div class="row">
					<div class="col-12">
						<div class="table-view-resource-wrapper" style="padding-top: 10px"
							*ngIf="resourceData && resourceData.length">
							<p-table #dt [value]="resourceData" responsiveLayout="scroll" id="editor">
								<ng-template pTemplate="header">
									<tr>
										<th *ngFor="let col of showColumns">
											<div [ngClass]="{ 'header-word-spacing': isFOView }">
												{{ translationsObj + col.key | translate }}
											</div>
										</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td *ngFor="let col of showColumns">
											<div [ngSwitch]="col.type">
												<div *ngSwitchCase="'enum'">
													<!-- Status Container -->
													<ng-container *ngIf="col.key === 'status'">
														<ng-container *ngIf="
																item[col.key] && item[col.key] === TABSTATUS.COMPLETED;
																else notComleted
															">
															<div>
																<span
																	[pTooltip]="translationsObj + item[col.key] | translate"
																	[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
																	<mat-icon
																		class="text-success h2">check_circle</mat-icon>
																</span>
															</div>
														</ng-container>
														<ng-template #notComleted>
															<ng-container *ngIf="
																	item[col.key] && item[col.key] === TABSTATUS.NOTCOMPLETED;
																	else noStatus
																">
																<div>
																	<span
																		[pTooltip]="translationsObj + item[col.key] | translate"
																		[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
																		<mat-icon
																			class="mat-close-circle h2">cancel</mat-icon>
																	</span>
																</div>
															</ng-container>
														</ng-template>
														<ng-template #noStatus>
															<div>
																<span
																	[pTooltip]="translationsObj + 'No Status' | translate"
																	[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
																	<mat-icon class="text-warning h2">error</mat-icon>
																</span>
															</div>
														</ng-template>
													</ng-container>

													<!-- Submitted Container -->
													<ng-container *ngIf="col.key === 'submitted'">
														<ng-container *ngIf="item[col.key]; else notExsit">
															<div>
																<span
																	[pTooltip]="translationsObj + item[col.key] | translate"
																	[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
																	<mat-icon
																		class="text-success h2">check_circle</mat-icon>
																</span>
															</div>
														</ng-container>
														<ng-template #notExsit>
															<div>
																<span
																	[pTooltip]="translationsObj + 'No Status' | translate"
																	[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
																	<mat-icon class="text-warning h2">error</mat-icon>
																</span>
															</div>
														</ng-template>
													</ng-container>
												</div>
												<div *ngSwitchCase="'Transalable'">
													<span class="transalable-item-text"
														[ngClass]="{ 'text-word-spacing': isFOView }">{{ translationsObj
														+ item[col.key] | translate }}</span>
												</div>
												<div *ngSwitchDefault>
													<span class="item-text" [ngClass]="{ 'item-text-FO': isFOView }"
														*ngIf="item[col.key]" [innerText]="item[col.key]">
													</span>
												</div>
											</div>
										</td>
									</tr>
								</ng-template>
							</p-table>
							<br />
						</div>
					</div>
				</div>
			</div>
		</p-dialog>
	</div>
</div>

<div class="table-view-resource-wrapper" id="summary" *ngIf="resourceData && resourceData.length">
	<p-table #dt [value]="resourceData" responsiveLayout="scroll" id="editor">
		<ng-template pTemplate="header">
			<tr>
				<th *ngFor="let col of showColumns">
					<div class="transalableSpan">
						{{ translationsObj + col.key | translate }}
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-item>
			<tr>
				<td *ngFor="let col of showColumns">
					<div [ngSwitch]="col.type">
						<div *ngSwitchCase="'enum'">
							<!-- Status Container -->
							<ng-container *ngIf="col.key === 'status'">
								<ng-container
									*ngIf="item[col.key] && item[col.key] === TABSTATUS.COMPLETED; else notComleted">
									<div>
										<span [pTooltip]="translationsObj + item[col.key] | translate"
											[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
											<mat-icon class="text-success h2">check_circle</mat-icon>
										</span>
									</div>
								</ng-container>
								<ng-template #notComleted>
									<ng-container
										*ngIf="item[col.key] && item[col.key] === TABSTATUS.NOTCOMPLETED; else noStatus">
										<div>
											<span [pTooltip]="translationsObj + item[col.key] | translate"
												[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
												<mat-icon class="mat-close-circle h2">cancel</mat-icon>
											</span>
										</div>
									</ng-container>
								</ng-template>
								<ng-template #noStatus>
									<div>
										<span [pTooltip]="translationsObj + 'No Status' | translate"
											[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
											<mat-icon class="text-warning h2">error</mat-icon>
										</span>
									</div>
								</ng-template>
							</ng-container>

							<!-- Submitted Container -->
							<ng-container *ngIf="col.key === 'submitted'">
								<ng-container *ngIf="item[col.key]; else notExsit">
									<div>
										<span [pTooltip]="translationsObj + item[col.key] | translate"
											[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
											<mat-icon class="text-success h2">check_circle</mat-icon>
										</span>
									</div>
								</ng-container>
								<ng-template #notExsit>
									<div>
										<span [pTooltip]="translationsObj + 'No Status' | translate"
											[tooltipPosition]="dir === 'rtl' ? 'left' : 'right'">
											<mat-icon class="text-warning h2">error</mat-icon>
										</span>
									</div>
								</ng-template>
							</ng-container>
						</div>
						<div *ngSwitchCase="'Transalable'">
							<span class="transalableSpan">{{ translationsObj + item[col.key] | translate }}</span>
						</div>
						<div *ngSwitchDefault>
							<ng-container *ngIf="item[col.key] && item[col.key].length > 25; else noSlicing">
								<ng-template #ItemTipContent>
									<div *ngIf="item[col.key]" [innerText]="item[col.key]"></div>
								</ng-template>
								<span>
									{{ item[col.key] | slice: 0:20 }} ...
									<i class="fa fa-eye pl-2 pr-2 eye-icon" id="tooltip-i" triggers="click"
										[autoClose]="'outside'" [ngbTooltip]="ItemTipContent"
										tooltipClass="my-custom-class" [openDelay]="200" [closeDelay]="200"></i></span>
								<!-- <mat-icon
									[matTooltip]="item[col.key]"
									[matTooltipPosition]="'above'"
									matTooltipClass="Custom-Tooltip"
									class="action-details"
									>remove_red_eye
								</mat-icon> -->

							</ng-container>
							<ng-template #noSlicing>
								<span *ngIf="item[col.key]" [innerText]="item[col.key]"> </span>

								<ng-template #tipContent>
									<div *ngIf="item[col.key]" [innerText]="item[col.key]"></div>
								</ng-template>

								<i *ngIf="item[col.key] && item[col.key]?.length > 0"
									class="fa fa-eye pl-2 pr-2 eye-icon" id="tooltip-i" triggers="click"
									[autoClose]="'outside'" [ngbTooltip]="tipContent" tooltipClass="my-custom-class"
									[openDelay]="200" [closeDelay]="200"></i>
							</ng-template>
						</div>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- <div
	[ngbPopover]="title"
	popoverTitle="Notes"
	[openDelay]="300"
	[closeDelay]="500"
	[autoClose]="'outside'"
>
	{{ title | slice: 0:30 }} ...
</div> -->